import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-662d8b32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner common--block common--block-small als" }
const _hoisted_2 = {
  key: 0,
  class: "banner--discount"
}
const _hoisted_3 = { class: "banner--image" }
const _hoisted_4 = {
  key: 0,
  alt: ""
}
const _hoisted_5 = { class: "banner--container flex-column justify-between" }
const _hoisted_6 = { class: "name leksa_title fz22 lh18" }
const _hoisted_7 = { class: "description lh16" }
const _hoisted_8 = { class: "more" }
const _hoisted_9 = {
  key: 0,
  class: "dates flex items-center"
}
const _hoisted_10 = { class: "referral flex items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "реферальная программа", -1))
const _hoisted_12 = { class: "banner--actions flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_clock_icon = _resolveComponent("clock-icon")!
  const _component_ref_icon = _resolveComponent("ref-icon")!
  const _component_edit_icon = _resolveComponent("edit-icon")!
  const _component_trash_icon = _resolveComponent("trash-icon")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.banner.discount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.banner.discount) + "%", 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.banner.image)
        ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_4, null, 512)), [
            [_directive_lazy, _ctx.banner.image.src]
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.banner.name), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.banner.description), 1),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.banner.startedAt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_clock_icon),
              _createElementVNode("span", null, _toDisplayString(_ctx.dateFilter(_ctx.banner.startedAt)) + " - " + _toDisplayString(_ctx.dateFilter(_ctx.banner.endedAt)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_ref_icon),
          _hoisted_11
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_edit_icon, {
        class: "cursor",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal('admin-banner-edit')))
      }),
      _createVNode(_component_trash_icon, {
        class: "cursor",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modal('admin-banner-delete')))
      })
    ])
  ]))
}